import { GridStateCommunity } from '../../../models/gridStateCommunity'
import { GridReactTableInstance } from '../../../models/gridReactTable'

export const gridRowsMetaSelector = ({
  tableInstance,
  state,
}: {
  state: GridStateCommunity
  tableInstance: GridReactTableInstance
}) => ({
  currentPageTotalHeight:
    tableInstance.getRowModel().rows.length * state.density.rowHeight,
})
